<template>
	<div>
		<div class="page-filter-box">
			<el-row :gutter="20">
				<el-col :sm="12" :md="8" :xl="4">
					<el-input v-model="params.searchValue" class="input-with-select" size="small">
						<el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
							<el-option label="用户ID" :value="1"></el-option>
							<el-option label="手机号码" :value="2"></el-option>
							<el-option label="支付平台交易号" :value="3"></el-option>
						</el-select>
					</el-input>
				</el-col>
				<el-col :sm="12" :md="8" :xl="4">
					<el-select v-model="params.orderStatus" placeholder="请选择" size="small">
						<el-option label="不限制订单状态" :value="0"></el-option>
						<el-option label="仅查看已完成的 " :value="1"></el-option>
						<el-option label="仅查看已过期的" :value="3"></el-option>
						<el-option label="仅查看已取消的" :value="2"></el-option>
					</el-select>
				</el-col>
				<el-col :sm="12" :md="8" :xl="4">
					<el-select v-model="params.payStatus" placeholder="请选择" size="small">
						<el-option label="不限制支付状态" :value="0"></el-option>
						<el-option label="仅看未支付的" :value="1"></el-option>
						<el-option label="仅看已支付的" :value="2"></el-option>						
					</el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
					<div class="clearfix timeType">
						<el-input class="input-with-select fl" size="small">
							<el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
								<el-option label="下单时间" :value="1"></el-option>
								<el-option label="支付时间" :value="2"></el-option>
								<el-option label="取消时间" :value="3"></el-option>
							</el-select>
						</el-input>
						<el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始日期"
							end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
							:default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
						</el-date-picker>
					</div>
				</el-col>
				<el-col :sm="12" :md="8" :xl="4" class="page-filter-btns">
					<el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
					<el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="page-btns-box">
			<el-button v-if="$utils.have('/member/order/export')" type="primary" icon="el-icon-download" size="small"
				@click="download" :loading="downLoading">导出订单</el-button>
		</div>
		<div class="page-list-box">
			<el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
				<el-table-column prop="sn" label="订单编号" min-width="100"></el-table-column>
				<el-table-column prop="orderTime" label="订单时间"></el-table-column>
				<el-table-column prop="amount" label="订单金额" width="80"></el-table-column>
				<el-table-column prop="userLevel" label="支付和订单状态">
					<template slot-scope="scope">
						<p>支付状态:{{scope.row.paymentStatus}}</p>
						<p>订单状态:{{scope.row.orderStatus}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="buyerId" label="购买人ID"></el-table-column>
				<el-table-column prop="tel" label="手机号码"></el-table-column>				
				<el-table-column prop="payMethod" label="支付方式"></el-table-column>
				<el-table-column prop="outTradeNo" label="支付平台交易号" min-width="100"></el-table-column>
				<el-table-column prop="payTime" label="支付时间"></el-table-column>
				<el-table-column fixed="right" label="操作" width="150">
					<template slot-scope="{row} = scope">
						<el-button v-if="$utils.have('/member/order/detail')" type="text" size="small"
							@click="details(row.id)" icon="el-icon-view">详情</el-button>
						<el-button v-if="$utils.have('/member/order/cancel') && row.paymentStatus === '已支付' && row.orderStatus ==='已完成'"
							type="text" size="small" icon="el-icon-circle-close" @click="cancel(row)">取消订单</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div v-if="data" class="page-pagination-box">
			<el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
				:current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
				layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
			</el-pagination>
		</div>

	</div>
</template>
<script>
	import {
		downloadFileTmp
	} from '@/assets/js/commonApi.js';
	const defaultParams = {
		pageNo: 1,
		searchType: 1,
		searchValue: '',
		orderStatus: 0,
		payStatus: 0,
		timeType: 1,
		beginTime: '',
		endTime: '',
	}
	export default {
		components: {

		},
		data() {
			return {
				data: null,
				dataList: null,
				params: {
					...defaultParams,
					pageNo: parseInt(this.$route.query.pageNo || 1),
					pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
					searchType: parseInt(this.$route.query.searchType || 1),
					searchValue: this.$route.query.searchValue || '',
					timeType: parseInt(this.$route.query.timeType || 1),
					beginTime: this.$route.query.beginTime || '',
					endTime: this.$route.query.endTime || '',
					orderStatus: parseInt(this.$route.query.orderStatus) || 0,
					payStatus: parseInt(this.$route.query.payStatus) || 0
				},
				listLoading: true,
				downLoading: false,
				datetimerange: [this.$route.query.beginTime || '', this.$route.query.endTime || ''],
			}
		},
		mounted() {
			this.getDataList();
		},
		methods: {
			//获取列表
			getDataList() {
				this.listLoading = true;
				this.$request({
						url: "/member/order/list",
						method: "POST",
						data: {
							...this.params,
							beginTime: this.datetimerange && this.datetimerange[0] || '',
							endTime: this.datetimerange && this.datetimerange[1] || '',
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result;
							this.dataList = result.result || [];
						} else {
							this.data = null;
							this.dataList = [];
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//选择pageSize
			handleSizeChange(e) {
				this.params.pageNo = 1;
				this.params.pageSize = e;
				this.getDataList();
			},
			//搜索
			search() {
				this.params.pageNo = 1;
				this.getDataList();
			},
			//重置搜索
			reset() {
				this.datetimerange = [];
				this.params = {
					...defaultParams,
					pageSize: this.params.pageSize,
				};
				this.getDataList();
			},
			async download() {
				this.downLoading = true;
				let filePath;
				const res = await this.$request({
						url: '/member/order/export',
						data: {
							...this.params,
							beginTime: this.datetimerange && this.datetimerange[0] || '',
							endTime: this.datetimerange && this.datetimerange[1] || '',
						},
						method: 'post',
					})
					.catch(err => {
						this.$message({
							message: err.message,
							type: 'error'
						});
					})
				const {
					state,
					msg,
					result
				} = res.data;
				if (state == 1 && result) {
					filePath = result.url;
					this.downLoading = false
				} else {
					return this.$message.error(msg || '下载失败');
					this.downLoading = false
				}

				await downloadFileTmp(filePath, result.fileName + '.' + this.$utils.getFileType(filePath));
			},
			cancel(data) {				
				const timeDiff = new Date().getTime() - new Date(data.payTime).getTime();
				const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
				if (daysDiff > 90) {
					return this.$message.error('订单支付已超过90天，不可取消!')
				}
				this.$confirm(`取消会员订单资金将直接发起原路退款，确定取消？`, '取消订单', {
					type: 'warning',
					center: true,
					closeOnClickModal: false,
					dangerouslyUseHTMLString: true,
				}).then(() => {
					this.$request({
							url: "/member/order/cancel",
							method: "POST",
							params: {
								orderId: data.id
							},
						})
						.then((res) => {
							const {
								state,
								msg
							} = res.data;
							if (state == 1) {
								this.$message.success("操作成功");
								this.getDataList();
							} else {
								this.$message.error(msg || "请求失败");
							}
						})


				}).catch(() => {

				})
			},
			//详情
			details(id) {
				this.$router.push({
					path: `/Members/order/details/${id}`,
					query: {
						redirect: this.$utils.objArgs(
							this.$router.currentRoute.path, {
								...this.params,
							}
						),
					},
				})
			}
		}
	}
</script>
<style lang="scss" scoped>

</style>